import { MOBILE_SHELL_QUERY } from '../hooks/useIsMobileShell';

const matches = (query) =>
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia(query).matches;

/** PWA instalado (Android/desktop: display-mode; iOS Safari: navigator.standalone). */
export function isStandalonePwa() {
    if (typeof window === 'undefined') return false;
    return matches('(display-mode: standalone)') || window.navigator.standalone === true;
}

/** Dispositivo móvel: viewport do shell mobile ou ponteiro por toque (celular/tablet). */
export function isMobileDevice() {
    return matches(MOBILE_SHELL_QUERY) || matches('(pointer: coarse)');
}

/** PWA instalado em dispositivo móvel. */
export function isMobileStandalonePwa() {
    return isStandalonePwa() && isMobileDevice();
}

export default isStandalonePwa;
